define([
    'handlebars',
    'modules/common/controls/select2base',
    'modules/common/templates/select2selectall.html',
    'appcontext',
    'utils/search/filterSearch'
], (Handlebars, Select2Base, Template, appContext, filterSearch) => Select2Base.extend({
    template: Handlebars.compile(Template),

    binders: _.extend({}, Select2Base.prototype.binders, {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.val());
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                if (value && view.options.lazyFetch) {
                    $.when(view.isFetched ? false : view.doLazyFetch()).done(() => {
                        view.val(value);
                    });
                } else {
                    view.val(value);
                }
            }
        }
    }),

    defaults: _.extend({
        id: 'id',
        text: 'name',
        width: '100%',
        allowSelectAll: true,
        sortable: false,
        lazyFetch: false,
        alwaysFetch: false
    }, Select2Base.prototype.defaults),

    doLazyFetch () {
        const self = this;
        const lazyFetch = this.options.lazyFetch;
        const fetchFunc = lazyFetch === true ? _.bind(this.options.choices.fetch, this.options.choices) : lazyFetch;
        this.isFetching = true;
        return fetchFunc().always(() => {
            self.isFetching = false;
        }).
            done(() => {
                self.isFetched = true;
            });
    },

    initialize () {
        Select2Base.prototype.initialize.apply(this, arguments);

        _.extend(this.options, {
            formatSelection: _.bind(this.formatSelection, this),
            formatResult: _.bind(this.formatResult, this),
            formatNoMatches: _.bind(this.formatNoMatches, this),
            formatInputTooShort: _.bind(this.formatInputTooShort, this),
            formatSelectionTooBig: _.bind(this.formatSelectionTooBig, this),
            formatSelectionCssClass: _.bind(this.formatSelectionCssClass, this),
            matcher: _.bind(this.matcher, this)
        });

        this.isFetching = false;
        this.isFetched = false;
        this.alwaysFetch = this.options.alwaysFetch;
        this.choices = this.options.choices;
        if (this.choices) {
            this.listenTo(this.choices, 'reset', this.resetValOnMissedChoices);
            this.listenTo(this.choices, 'reset', this.render);
        }
        this.filtered = [];

        if (this.options.lazyFetch) {
            const self = this;
            this.on('select2-opening', () => {
                if (!self.isFetched && !self.isFetching) {
                    const spinClass = 'select2-spin';
                    const spinTarget = self.$el.siblings().find('.select2-search-field');
                    const spinInput = spinTarget.find('.select2-input');
                    spinTarget.addClass(spinClass);
                    spinInput.attr('disabled', 'true');
                    return self.doLazyFetch().always(() => {
                        spinTarget.removeClass(spinClass);
                        spinInput.attr('disabled', 'false');
                    }).
                        done(() => {
                            self.open();
                            if (self.alwaysFetch) {
                                self.isFetched = false;
                            }
                        });
                }
            });
        }
    },

    formatSelection (state) {
        return _.escape(state[this.options.text]);
    },

    formatSelectionCssClass () {
        return undefined;
    },

    formatResult (state) {
        return _.escape(state[this.options.text]);
    },

    formatSelectionTooBig (limit) {
        return appContext.ngettext('You can only select %d item', 'You can only select %d items', limit);
    },

    formatNoMatches () {
        return appContext.tr('No matches found');
    },

    formatInputTooShort (input, min) {
        const n = min - input.length;
        return appContext.ngettext('Please enter %d more character', 'Please enter %d more characters', n);
    },

    matcher (term, text, option) {
        const filteredTerm = filterSearch.default(term);

        return _.isUndefined(option.children) &&
                option[this.options.text].toUpperCase().indexOf(filteredTerm.toUpperCase()) >= 0;
    },

    /*
     * Select2 val() function always returns strings, but we need to have actual ids of collection models.
     * So we use data() function to access objects.
     */
    val () {
        const multiple = this.options.multiple;
        if (arguments.length === 0) {
            const data = this.data();
            const idAttr = this.options.id;
            return multiple ? data.map((state) => state[idAttr]) : data ? data[idAttr] : null;
        }

        // We need to wrap values into array in case of multiple select2 and if only single value selected.
        if (multiple) {
            let values = [].shift.call(arguments);
            if (values) {
                values = _.wrapArray(values);
            }
            [].unshift.call(arguments, values);
        }
        return Select2Base.prototype.val.apply(this, arguments);

    },

    setupSortable () {
        const el = this.$el;
        this.$el.select2('container').find('ul.select2-choices').
            sortable({
                containment: 'parent',
                start () {
                    el.select2('onSortStart');
                },
                update () {
                    el.select2('onSortEnd');
                }
            });
    },

    setupSelectAll () {
        const self = this;

        function selectAll () {
            self.updateFiltered();
            self.close();
            self.$el.trigger('change');
            return false;
        }

        function deselectAll () {
            let data = [];

            // Do not clear locked elements.
            if (self.options.locked) {
                data = _.filter(self.data(), (x) => x.locked);
            }

            self.data(data);
            self.close();
            self.$el.trigger('change');
            return false;
        }

        function addSelectAllLi () {
            const select2drop = self.dropdown();
            if (select2drop.find('.select2-select-all').length) {
                return;
            }
            const ul = select2drop.find('ul.select2-results');
            const li = $('<li>').addClass('select2-select-all');
            const div = $('<div>').addClass('select2-result-label');
            const template = $(self.template());

            template.appendTo(div);
            div.appendTo(li);
            li.prependTo(ul);

            div.find('.select-all').on('click', selectAll);
            div.find('.deselect-all').on('click', deselectAll);
        }

        function loaded (event) {
            self.filtered = [];
            _.each(event.items.results, (result) => {
                if (result.children) {
                    _.each(result.children, (child) => {
                        self.filtered.push(child);
                    });
                } else {
                    self.filtered.push(result);
                }
            });

            addSelectAllLi();
        }

        function onInput () {

            // if there is no filtered elements we resetting filtered
            if (!self.dropdown().find('.select2-result-selectable').length) {
                self.filtered = [];
            }
            addSelectAllLi();
        }

        const container = self.$el.select2('container');
        const searchInput = $(container.find('input:first'));

        // we need to render on each input event because select2 doesn't trigger any event when no matches found
        searchInput.on('input', onInput);

        this.on('select2-open', addSelectAllLi);
        this.on('select2-loaded', loaded);
    },

    render () {
        Select2Base.prototype.render.apply(this, arguments);

        const options = _.clone(this.options);

        if (this.choices) {
            options.data = this.choices.toJSON();
        }

        /*
         * Check display property because element can be not rendered (attached to DOM) yet.
         * But it will be visible after render and attach.
         */
        const wasVisible = this.$el.select2('container').css('display') !== 'none';

        // this.$el is expected to be already attached to DOM at this moment
        this.$el.select2('destroy').select2(options);

        if (this.wasRendered && !wasVisible) {
            this.$el.select2('container').hide();
        }
        this.wasRendered = true;

        if (options.sortable) {
            this.setupSortable();
        }

        if (options.multiple && options.allowSelectAll) {
            this.setupSelectAll();
        }

        return this;
    },

    remove () {
        this.$el.select2('destroy');
        Select2Base.prototype.remove.apply(this, arguments);
    },

    updateFiltered () {
        return this.data(_.union(this.data(), this.filtered));
    },

    setChoices (models) {
        this.choices.reset(models);
    },

    disableFetch () {
        this.isFetched = false;
    },

    resetValOnMissedChoices () {
        const multiple = this.options.multiple;
        const idAttr = this.options.id;
        const val = this.val();

        // force reset selected data if there is no choice/choices in this.choices
        if (multiple) {
            if (!_.isEmpty(val)) {
                const choices = this.choices.chain().
                    filter((model) => _.contains(val, model.get(idAttr))).
                    pluck(idAttr).
                    value();

                if (_.isEmpty(_.difference(val, choices))) {
                    return;
                }

                this.val(_.intersection(val, choices), true);
            }
        } else if (!_.isNull(val)) {
            const choice = this.choices.find((model) => model.get(idAttr) === val);
            if (!_.isUndefined(choice)) {
                return;
            }
            this.val(null, true);
        }
    }

}));
